import React, { useEffect, useState } from 'react';
import FormField from 'components/Form/FormField';
import TagsMultiSelectDropdown from 'components/DropdownSelect/MultiSelectDropdown/Usage/TagsMultiSelectDropdown';
import Filters from 'components/Filters/Filters';
import { StoresFilter, useStoresContext } from 'pages/Stores/stores.context';
import UsersMultiSelectDropdown from 'components/DropdownSelect/MultiSelectDropdown/Usage/UsersMultiSelectDropdown';
import BrandsMultiSelectDropdown from 'components/DropdownSelect/MultiSelectDropdown/Usage/BrandsMultiSelectDropdown';
import { useAuthContext } from 'context/auth.context';
import { hasPermissions } from 'config/ability';

const StoresFilters = () => {
  const { storesFilter, setStoresFilter } = useStoresContext();
  const { ability, user, userTenantId } = useAuthContext();
  const [filters, setFilters] = useState(storesFilter);

  useEffect(() => {
    setFilters(storesFilter);
  }, [storesFilter]);

  const handleChangeField = (
    value: string | number | number[] | boolean | undefined,
    key: keyof StoresFilter
  ) => {
    if (Array.isArray(value) && !value.length) {
      setFilters({ ...filters, [key]: [] });
    } else {
      setFilters({ ...filters, [key]: value });
    }
  };

  const clearFilters = () =>
    setStoresFilter({
      tenantId: userTenantId,
      userIds:
        !user || hasPermissions(ability, 'read', 'Store', { tenantId: userTenantId })
          ? []
          : [user.user.id],
    });

  const filterInputs = [
    <FormField
      field={{
        label: 'Filter by name',
        value: filters.name,
        containedLabel: true,
        onChange: () => {},
        fieldProps: {
          size: 'small',
        },
      }}
      onChange={(searchText) => handleChangeField(searchText, 'name')}
      key='name'
    />,
    <FormField
      field={{
        label: 'State name',
        value: filters.state,
        containedLabel: true,
        onChange: () => {},
        fieldProps: {
          size: 'small',
        },
      }}
      onChange={(stateName) => handleChangeField(stateName, 'state')}
      key='state'
    />,
    <TagsMultiSelectDropdown
      selectedTagIds={filters.tagIds}
      containedLabel={true}
      onChange={(tags) =>
        handleChangeField(
          tags.map((tag) => tag.id!),
          'tagIds'
        )
      }
      inputProps={{
        size: 'small',
      }}
      key='tags'
    />,
    <UsersMultiSelectDropdown
      key='User Names'
      selectedUserIds={filters.userIds}
      containedLabel={true}
      onChange={(users) =>
        handleChangeField(
          users.map((user) => user.id!),
          'userIds'
        )
      }
      inputProps={{
        size: 'small',
      }}
    />,
    <UsersMultiSelectDropdown
      key='Store Managers'
      label='Store Managers'
      selectedUserIds={filters.storeManagerUserIds}
      containedLabel={true}
      onChange={(users) =>
        handleChangeField(
          users.map((user) => user.id!),
          'storeManagerUserIds'
        )
      }
      inputProps={{
        size: 'small',
      }}
    />,
    <BrandsMultiSelectDropdown
      key='Brands'
      selectedBrandIds={filters.brandIds}
      containedLabel={true}
      onChange={(brands) =>
        handleChangeField(
          brands.map((brand) => brand.id!),
          'brandIds'
        )
      }
      inputProps={{
        size: 'small',
      }}
    />,
  ];

  const hasFilters = !!Object.entries(filters).find(
    (filter) => filter[0] !== 'tenantId' && (filter[1]?.length || filter[1] > 0)
  );

  return (
    <Filters
      filterInputs={filterInputs}
      onApplyFilters={() => setStoresFilter(filters)}
      onClearFilters={clearFilters}
      hasFilters={hasFilters}
    />
  );
};

export default StoresFilters;
